export default __webpack_public_path__ + "static/navigator-icon-c132313578443558648c97e4def83637.png";